<template>
	<page>
		<module :title="id ? '编辑商家角色' : '新建商家角色'">
			<c-form ref="form">
				<c-form-item type="hidden" label="商家类型" name="stationed_type" value="1"></c-form-item>
				<c-form-item type="input" label="商家角色名称" name="auth_name" required></c-form-item>
				<c-form-item type="radio" label="发布商品审核" name="is_product_check" :options="checkOptions" :value="2" word="" required></c-form-item>
				<c-form-item type="select" v-model="operationMode" label="运营模式" name="operation_mode" :options="operationModeOptions" required></c-form-item>
				<c-form-item type="radio" label="结算账户类型" name="settlement_account_type" :value="settlement_account_type" :options="settlementAccountType" required :disabled = "issettlement_account_type_disabled"></c-form-item>
				<c-form-item type="radio" label="是否开通店铺" name="is_open_shop" :options="isOpenShopOptions" :value="is_open_shop" word="" required :disabled = "isis_open_shop_disabled"></c-form-item>
				<c-form-item type="radio" label="平台盈利模式" name="platform_profit_model" :options="profitModelOptions" :value="2" word="" required></c-form-item>
				<c-form-item label="权限配置" >
					<power-tree :power-list="powerList"></power-tree>
				</c-form-item>
				<c-form-item type="textarea" label="备注" name="remark"></c-form-item>
			</c-form>
			
			<template slot="button">
				<c-button size="m" @click="submit">提交保存</c-button>
			</template>
		</module>
	</page>
</template>

<script>
	function renderPower(h, list, parent) {
		var arr = [], last = !list.find(item => item.children.length);
		list.map(item => {
			item.parent = parent;
			
			arr = arr.concat([
				<div class="power-item" style={`float: ${last ? 'left' : 'none'}`}>
					<c-checkbox checked={item.chk != 0} on-click={$event => this.checkHandle(item, $event)}>{item.name}</c-checkbox>
					{
						item.children.length ? [
							<div class="power-list">
								{
									renderPower.call(this, h, item.children, item)
								}
							</div>
						] : []
					}
				</div>
			]);
		});
		
		return arr;
	}
	
	const powerTree = {
		render(h) {
			return (
				<div class="power">
					{
						renderPower.call(this, h, this.powerList)
					}
				</div>
			)
		},
		
		props: {
			powerList: Array
		},
		
		methods: {
			checkHandle(power, state) {
				state = state ? 1 : 0;
				
				power.chk = state;
				!function poll(list) {
					list.forEach(item => {
						item.chk = state;
						poll(item.children);
					});
				}(power.children);
				
				!function poll(parent) {
					if (parent) {
						parent.chk = parent.children.find(item => !!item.chk) ? 1 : 0;
						poll(parent.parent);
					}
				}(power.parent);
			}
		}
	};
	
	export default {
		name: 'stationed_auth_edit',
		
		components: {
			powerTree
		},
		
		props: {
			id: String
		},
		
		data() {
			return {
				is_firest: true,
				operationMode: 1,
				is_open_shop: 1,
				issettlement_account_type_disabled: false,
				isis_open_shop_disabled: true,
				settlement_account_type: 1,
				powerList: [],
				checkOptions: [{
					name: '不需要',
					value: 1
				}, {
					name: '需要',
					value: 2
				}],
				profitModelOptions: [{
					name: '向商家抽取服务费',
					value: 1
				}, {
					name: '平台加价销售',
					value: 2
				}],
				isOpenShopOptions: [{
					name: '无店铺',
					value: 1
				}, {
					name: '开通店铺',
					value: 2
				}],
				operationModeOptions: [{
					name: '平台运营',
					value: 1
				},{
					name: '商家自营',
					value: 2
				}],
				settlementAccountType: [{
					name: '平台统收账户',
					value: 1
				},{
					name: '商家独立账户',
					value: 2
				}]
			}
		},
		
		watch: {
			id() {
				this.update();
			},
			operationMode() {
				if(!this.id){
					this.is_firest = false;
				}
				console.log(this.is_firest)
				//平台运营
				if(this.operationMode == 1){
					if(!this.is_firest){
						this.settlement_account_type = 1;
						this.is_open_shop = 1;
					}
					this.issettlement_account_type_disabled = false;
					this.isis_open_shop_disabled = true;
				//商家运营
				}else if(this.operationMode == 2){
					if(!this.is_firest){
						this.settlement_account_type = 2;
						this.is_open_shop = 2;
					}
					this.issettlement_account_type_disabled = true;
					this.isis_open_shop_disabled = false;
				}
				this.is_firest = false;
			}
		},
		
		mounted() {
			this.update();
		},
		
		methods: {
			update() {
				this.request({
					url: '/stationed/auth/detail',
					data: {
						auth_id: this.id || 0
					},
					success: data => {
						if (this.id) {
							// this.operationMode = data.info.operationMode;
							this.settlement_account_type = data.info.settlement_account_type;
							this.is_open_shop = data.is_open_shop;
							
							this.$refs.form.set(data.info);
						}
						this.powerList = data.auth_menu;
					}
				});
			},
			
			submit() {
				this.$refs.form.submit({
					url: this.id ? '/stationed/auth/edit' : '/stationed/auth/add',
					rule: {
						auth_name: '请填写商家角色名称',
						operation_mode: '请选择运营模式',
						settlement_account_type: '请选择结算账户类型'
					},
					dataFormatter: data => {
						data.auth_id = this.id;
						data.auth_menus = [];
						!function poll(list) {
							list.forEach(item => {
								if (item.chk) {
									data.auth_menus.push({
										menu_id: item.id
									});
								}
								poll(item.children);
							});
						}(this.powerList);
						return data;
					},
					success:(data,res) => {
						this.$message({
							text: '保存成功'
						});
						this.$bus.$emit('authList.update', this.id ? undefined : 1);
						this.redirectTo('/stationed_auth_list');
					},
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	>>> .power {
		max-height: 500px;
		border: 1px solid #ddd;
		overflow: auto;
			
		&-list {
			margin-left: 40px;
			overflow: hidden;
		}
		
		> &-item {
			margin-left: 20px;
			
			&:nth-last-child(1) {
				margin-bottom: 15px;
			}
		}
		
		&-item {
			margin-top: 15px;
			margin-right: 20px;
		}
	}
</style>